// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PillBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.407 4.596a7.16 7.16 0 0 0-10.125 0L4.596 17.282a7.16 7.16 0 0 0 10.125 10.125l12.686-12.69a7.166 7.166 0 0 0 0-10.12Zm-14.81 20.686a4.156 4.156 0 0 1-6.845-4.525c.23-.51.56-.97.97-1.35L12 14.125 17.875 20l-5.277 5.282Zm12.688-12.686L20 17.875 14.125 12l5.284-5.283a4.158 4.158 0 0 1 5.875 5.875l.001.004ZM24.064 9.44a1.499 1.499 0 0 1 0 2.125l-3 3a1.501 1.501 0 0 1-2.451-1.638c.076-.182.186-.348.326-.487l3-3a1.5 1.5 0 0 1 2.125 0Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
